import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';
import { ArgoUdfColumnDataTypeEnum } from '../../../../../db';
import { locationSchema } from '../../location.deployParam';

export const createMaterialNodeCfgSchema = baseNodeCfgSchema.extend({
    controlValues: z.object({
        allowGet: z.boolean().default(false),
        location: locationSchema,
        materialModelId: z.string(),
        snCfg: z.discriminatedUnion('kind', [
            z.object({ kind: z.literal('direct') }),
            z.object({
                fmtInputs: z.array(z.string()), // this is to generate the inputs for the formatter
                kind: z.literal('formatter'),
            }),
        ]),
        udfs: z.record(z.string(), z.object({
            name: z.string(),
            required: z.boolean(),
            type: z.nativeEnum(ArgoUdfColumnDataTypeEnum),
        })),
    }),
    kind: z.literal('createMaterial'),
});
export type CreateMaterialNodeCfgSchema = z.infer<typeof createMaterialNodeCfgSchema>;

export const createMaterialNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({ trigger: 'event' }),
        outputs: () => ({ next: 'event' }),
    },
    dataSockets: {
        inputs: (cfg: NodeCfg<'createMaterial'>): Record<`udfInput_${string}` | 'sn' | `snInput_${string}` | 'workOrderId', 'varValue' | 'string'> => {
            const inputs = {
                workOrderId: 'string',
            } as Record<`udfInput_${string}` | 'sn' | `snInput_${string}` | 'workOrderId', 'varValue' | 'string'>;

            for (const udfId in cfg.controlValues.udfs) {
                inputs[`udfInput_${udfId}`] = 'varValue';
            }

            if (cfg.controlValues.snCfg.kind === 'direct') {
                inputs.sn = 'varValue';
            } else {
                for (const fmtInput of cfg.controlValues.snCfg.fmtInputs) {
                    inputs[`snInput_${fmtInput}`] = 'varValue';
                }
            }
            return inputs;
        },
        outputs: () => ({ materialId: 'string', serialNumber: 'string' }),
    },
} satisfies NodeSocketCfg<CreateMaterialNodeCfgSchema>;
